/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Quote email types for testing
 */
export var QuoteEmailType;

(function (QuoteEmailType) {
  QuoteEmailType["DROPOUT_BEFORE_QUOTE"] = "dropout_before_quote";
  QuoteEmailType["DROPOUT_BEFORE_PAYMENT"] = "dropout_before_payment";
})(QuoteEmailType || (QuoteEmailType = {}));